module.exports = __webpack_public_path__ + "img/brandTeaser.31c9d4cd.svg";